var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"dropdown-menu",attrs:{"role":"menu"}},[_c('li',{staticClass:"h100p"},[_c('ul',{staticClass:"dropdown-menu__list dropdown-menu__list--level-one"},_vm._l((_vm.categories),function(category,key){return _c('category-level-one',{key:key,attrs:{"link":category}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }